export enum ECounterpartyProcessingSearchForm {
  CounterpartyName= 'counterpartyName',
  WalletAccountGUID = 'wallet_account_guids',
  BranchName = 'branch_name',
}

export enum ERowAction {
  Edit = 'edit',
  Delete = 'delete',
}

export enum EModalType {
  Create = 'create',
  Edit = 'edit',
}

export enum EAccountManagementCounterpartyProcessingPageGetParams {
  Action = 'action',
}

export enum EAccountManagementCounterpartyProcessingPageGetParamsActionTypes {
  Create = 'create',
}
